import { FilePreview } from "@/components/Form/types";
import isFileAccepted from "./isFileAccepted";
import { v4 as uuidv4 } from 'uuid'


interface FileDataParams {
    file: File | null;
    fileExtension?: string | null;
    url?: string | null;
    types?: string;
}

const createFileData = ({ file, url = null, fileExtension = null, types }: FileDataParams): Promise<FilePreview | null> => {
    return new Promise((resolve) => {

        if (file && isFileAccepted(file, types)) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            const extension = fileExtension || file.name.split(".").pop() || null;

            reader.onload = () => {
                resolve({
                    data: file,
                    string: reader.result as string,
                    name: decodeURIComponent(file.name),//file.name.length > 50 ? file.name.slice(0, 50) + "..." : file.name,
                    size: file.size,
                    type: file.type,
                    url: url || undefined,
                    fileExtension: extension,
	                uuid: uuidv4()
                });
            };
        } else if (file) {
            alert("The selected file format is not supported.");
            resolve(null);
        } else {
            resolve(null);
        }
    });
};

export default createFileData;